var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-wrapper"},[_c('div',{staticClass:"text-center mb-4"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":_vm.path}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }